import { SchemaField } from "../../types/fieldForm";

/**
 * Applies a calculated field's presentation setting without changing the stored
 * value. Values remain raw in row_data so expressions and exports stay stable.
 */
export function formatCalculatedValue(field: SchemaField, value: unknown): string {
  if (value == null || value === "") return "";
  const format = field.format === "date" || field.format === "currency" || field.format === "text" ? field.format : "number";

  if (format === "text") return String(value);

  if (format === "date") {
    // Date-only values are calendar dates, not UTC timestamps. Constructing them
    // locally prevents a west-of-UTC browser from displaying the previous day.
    const dateOnly = typeof value === "string" && value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    const date = dateOnly
      ? new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
      : value instanceof Date
        ? value
        : new Date(String(value));
    return Number.isNaN(date.getTime()) ? String(value) : new Intl.DateTimeFormat(undefined, { dateStyle: "medium" }).format(date);
  }

  const number = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(number)) return String(value);

  if (format === "currency") {
    try {
      return new Intl.NumberFormat(undefined, { style: "currency", currency: field.currency ?? "USD" }).format(number);
    } catch {
      return new Intl.NumberFormat().format(number);
    }
  }
  return new Intl.NumberFormat().format(number);
}
